var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'has-notice': !!_vm.notice },attrs:{"id":"app"}},[_c(_vm.$route.meta.layout,{tag:"component"}),(_vm.isFooterVisible)?_c('site-footer'):_vm._e(),_c('notifications',{attrs:{"group":"app","position":"bottom right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }